import { render, staticRenderFns } from "./addCategory.vue?vue&type=template&id=623b43ad&scoped=true"
import script from "./addCategory.vue?vue&type=script&lang=js"
export * from "./addCategory.vue?vue&type=script&lang=js"
import style0 from "./addCategory.vue?vue&type=style&index=0&id=623b43ad&prod&scoped=true&lang=css"
import style1 from "./addCategory.vue?vue&type=style&index=1&id=623b43ad&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "623b43ad",
  null
  
)

export default component.exports